/**
 * Hashes a string using SHA-256 and returns the hex representation.
 * This matches the Java MessageDigest implementation.
 * @param password The string to hash.
 * @returns A promise that resolves to the hex-encoded hash.
 */
export async function hashPassword(password: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // Convert buffer to byte array
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  
  // Convert bytes to hex string
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
    
  return hashHex;
}
